import { render, staticRenderFns } from "./StocksConfiguration.vue?vue&type=template&id=32721bcc&"
import script from "./StocksConfiguration.vue?vue&type=script&lang=js&"
export * from "./StocksConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports